import { format, addMonths, subMonths } from 'date-fns';
import './MonthToggle.css';
import { DateInput } from '../../types/DateInput';
import Section from '../Modular/Section';
import Unit from '../Modular/Unit';
import MicroUnit from '../Modular/MicroUnit';
import Button from '../Button';
import { useWindowSize } from '../../hooks/useWindowSize';

interface MonthToggleProps {
  date: DateInput;
  onChange: (newDate: Date) => void;
}

const MonthToggle: React.FC<MonthToggleProps> = ({ date, onChange }) => {
  const today = new Date(date.year, date.month, date.day || 1);
  const windowSize = useWindowSize();

  const marginTop = windowSize.width <= 768 ? 'lg' : '';
  const marginBottom = windowSize.width <= 798 ? '' : 'md';
  const margin = windowSize.width <= 798 ? '' : '';
  // const marginRight = windowSize.width <= 798 ? '' : '';
  // const fontSize = windowSize.width <= 798 ? '2xl' : 'md';
  const width = windowSize.width <= 798 ? '6' : '8';
  const mobileClass = windowSize.width <= 798 ? 'mobile' : '';

  console.log(date);

  const handlePrev = () => onChange(subMonths(today, 1));
  const handleNext = () => onChange(addMonths(today, 1));

  return (
    <Unit
      layout="flex"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      width={width}
      widthMax={'400'}
      // margin="horizontal-auto"
      marginTop={marginTop}
      marginBottom={marginBottom}
      justifySelf="center"
    >
      <Button
        className="arrow-button"
        onClick={handlePrev}
        aria-label="Previous Month"
      >
        &lsaquo;
      </Button>
      <div className={`month-label ${mobileClass}`}>
        {format(today, 'MMMM')}
      </div>
      <Button
        className="arrow-button"
        onClick={handleNext}
        aria-label="Next Month"
      >
        &rsaquo;
      </Button>
    </Unit>
  );
};

export default MonthToggle;
